import React from 'react';
import classNames from 'classnames';
import {
  Dialog, DialogClose, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  addressFormatter, optionClassFormatter, statusNameFormatterWithZone,
} from '../../../utils/formatters';
import {
  CamerasActionsFormatter,
  MoreFormatter,
  StatusFormatter,
  StatusFormatterWithProblem,
  CamerasWorkingStateFormatter,
} from './CamerasFormatters';

export default function CamerasPopup(props) {
  const { handleClose = () => {}, item } = props;
  if (!item) {
    return null;
  }
  const {
    zbx_address,
  } = item;
  return (
    <Dialog
      onClose={handleClose}
      open
      className="parking-meter-popup"
      size="xl"
    >
      <DialogTitle header="Информация о видеокамере" title={<DialogClose onClick={handleClose} />} />
      <DialogContent>
        <div className="pmp-table">
          <div className={classNames('pmp-table-row', optionClassFormatter(item.status))}>
            <div className="pmp-table-cell">Номер видеокамеры</div>
            <div className="pmp-table-cell">{statusNameFormatterWithZone(null, item)}</div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Адрес факт./юрид.</div>
            <div className="pmp-table-cell">{addressFormatter(zbx_address)}</div>
          </div>
          <div className="pmp-table-row pm-status">
            <div className="pmp-table-cell">Состояние</div>
            <div className="pmp-table-cell"><StatusFormatterWithProblem item={item} /></div>
          </div>
          <div className="pmp-table-row pm-last-ping">
            <div className="pmp-table-cell">Дата и время сбора данных</div>
            <div className="pmp-table-cell"><StatusFormatter item={item} /></div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Работа устройства</div>
            <div className="pmp-table-cell"><CamerasWorkingStateFormatter item={item} isPopup /></div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Действие</div>
            <div className="pmp-table-cell pm-popup-actions">
              <CamerasActionsFormatter item={item} />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
